import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Our Work", to: "/our-work" },
  { label: "Services", to: "/services" },
  { label: "Contact Us", to: "/contact-us" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="bg-white shadow-sm border-b border-white-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-2 py-3 flex justify-between">
        <div className="hidden md:flex items-center space-x-10">
        <Link to="/" className="flex items-center">
          <img src="/images/logo.png" alt="SR Next" className="h-8 w-auto object-contain" />
        </Link>


          {navItems.map(({ label, to }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `text-sm font-semibold transition hover:text-red-600 ${
                  isActive ? "text-red-600" : "text-black"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:block">
          <Link
            to="/contact-us"
            className="btn btn-orange"
          >
            Contact us
          </Link>
        </div>

        <button
          className="md:hidden text-gray-700"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden px-6 pb-4 space-y-3">
          {navItems.map(({ label, to }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => setMobileOpen(false)}
              className={({ isActive }) =>
                `block text-sm font-medium py-1 ${
                  isActive ? "text-red-600" : "text-gray-800"
                } hover:text-red-600`
              }
            >
              {label}
            </NavLink>
          ))}
          <Link
            to="/contact-us"
            className="inline-block w-full text-center bg-red-600 text-white text-sm font-medium py-2 rounded-md hover:bg-red-700"
            onClick={() => setMobileOpen(false)}
          >
            Contact us
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Header;
